module.exports = __webpack_public_path__ + "img/7-en.4b947cd7.png";